<template>
     <div class="center-me">
      <div
        class="btn shadow_y main-btn"
      :class="[btnclass, btn]"
        @click="$emit('method')"
      >
        <p
        v-if="text"
        :class="[textStyle]"
          class="main-btn-text"
        >
          {{text}}
          </p>
        <slot v-else name="svg"></slot>
      </div>
    </div>
</template>

<script>
export default {
    props: ["text", "btnclass", "textStyle", "btn"]
}
</script>

<style>
.main-btn {
    margin-top: 30px;
    background: #FFBD2E !important;
    line-height: 2.2;
    display: flex;
    justify-content: center;
}
.main-btn-text {
  font-weight: 500;
    color: #000; margin: 0 !important; font-size: 1.1rem !important; letter-spacing: 0.4px !important;
}
</style>